import { useLazyGetProfileQuery } from "Data/services/userAuthApi";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "store";
import { WEB_ROUTES } from "../../constants";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
}): JSX.Element => {
  const { isLoggedIn } = useSelector((state: RootState) => state.auth)
  // const token = true;

  // Inject Data
  const [getProfile] = useLazyGetProfileQuery();
  // console.log("Protected Route", );

  useEffect(() => {
    getProfile();
  }, []);

  return isLoggedIn ? (
    <>{children}</>
  ) : (
    <Navigate to={WEB_ROUTES.ACCOUNT} replace={true} />
  );
};

export default ProtectedRoute;
